module.exports = new __parcel__URL__("c1s14.5753445f.png").toString();